import { Loading } from 'Components'
import { useAuth } from 'Hooks'
import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'
// import { removeLocalStorage, STORAGE } from 'Utils'
// import { USER_URL, SIGNAL_TYPE } from 'Constants'

const LogoutScreenStyled = styled.div`
  h1 {
    margin-bottom: 26px;
  }
  .ant-col.ant-col-24 {
    margin-bottom: 14px;
  }
  .form-group {
      margin: 0 16px 12px;
  }
  .title-info {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .button-edit {
      margin-left: 14px;
      cursor: pointer;
  }
  .form-body {
    margin-top: 44px;
  }
  .row-icon {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
`

const LogoutHiddenScreen = () => {
  const { logOutAction, authenticated } = useAuth()
  const history = useHistory()
  useEffect(() => {
    logOutAction(true)
  }, [])

  useEffect(() => {
    if (!authenticated) setTimeout(() => history.push('/'), 500)
  }, [authenticated])

  return (
    <LogoutScreenStyled>
      <Loading />
    </LogoutScreenStyled>
  )
}

export default LogoutHiddenScreen
